import React from 'react';
import { useRouter } from 'next/router';

import { LayoutEmbed } from '../../components/layout/LayoutEmbed';
import { ScheduleMapEmbed } from '../../widgets/ScheduleMapEmbed';

function ScheduleMap() {
  const {
    isReady,
    query: {
      day_picker_label,
      hide_day_picker,
      hide_location_search,
      latitude,
      longitude,
      marker_height = '64',
      marker_image,
      marker_width = '64',
      organization_id,
      radius = '50',
      rows = '100',
      select_zoom = '19',
      vendor_id,
      zoom = '15',
    },
  } = useRouter();

  const getParam = (value: string | string[] | undefined) =>
    Array.isArray(value) ? value[0] : value;

  const markerHeightValue = getParam(marker_height) ?? '64';
  const markerImageValue = getParam(marker_image);
  const markerWidthValue = getParam(marker_width) ?? '64';
  const radiusValue = getParam(radius) ?? '50';
  const rowsValue = getParam(rows) ?? '100';
  const selectZoomValue = getParam(select_zoom) ?? '19';
  const zoomValue = getParam(zoom) ?? '15';

  return (
    <ScheduleMapEmbed
      markerHeight={Number(markerHeightValue)}
      markerWidth={Number(markerWidthValue)}
      selectZoom={Number(selectZoomValue)}
      zoom={Number(zoomValue)}
      canvasCss={{
        height: '100vh',
      }}
      markerImage={
        typeof markerImageValue === 'string' ? markerImageValue : undefined
      }
      scheduleOptions={{
        dayPickerLabel: getParam(day_picker_label),
        hideDayPicker: getParam(hide_day_picker),
        hideLocationSearch: getParam(hide_location_search),
        isReady,
        latitude: getParam(latitude),
        longitude: getParam(longitude),
        organizationId: getParam(organization_id),
        radius: radiusValue,
        rows: rowsValue,
        selectZoom: selectZoomValue,
        vendorId: getParam(vendor_id),
      }}
    />
  );
}

ScheduleMap.getLayout = function getLayout(page: React.ReactElement) {
  return <LayoutEmbed>{page}</LayoutEmbed>;
};

export default ScheduleMap;
